import Button from 'lib/ui/Button'
import GroupInput from 'lib/ui/form/GroupInput'
import Skeleton from '@material-ui/lab/Skeleton'
import {spacing} from 'lib/ui/theme'
import React from 'react'
import styled from 'styled-components'
import {Group} from 'organization/Event/AttendeesProvider'
import {Widget} from 'Event/Widget/template'

export default function GroupsConfig(props: {
  widget: Widget | null
  updateWidget: (updatedFields: Partial<Widget>) => void
}) {
  const {widget, updateWidget} = props

  if (!widget) {
    return <Skeleton height={100} />
  }

  const addGroup = () => {
    const added = [...(widget.groups ?? []), {key: '', value: ''}]
    updateWidget({groups: added})
  }

  const updateGroup = (targetIndex: number) => (updated: Group) => {
    const updatedList = widget.groups.map((g, i) => {
      const isTarget = i === targetIndex
      if (isTarget) {
        return updated
      }

      return g
    })

    updateWidget({groups: updatedList})
  }

  const removeGroup = (targetIndex: number) => () => {
    const updated = [...widget.groups]
    updated.splice(targetIndex, 1)
    updateWidget({groups: updated})
  }

  return (
    <>
      <StyledGroupInputHolder>
        {widget.groups?.map((group, index) => (
          <GroupInput
            key={index}
            group={group}
            onChange={updateGroup(index)}
            remove={removeGroup(index)}
          />
        ))}
      </StyledGroupInputHolder>
      <Button
        aria-label="add group"
        variant="outlined"
        color="primary"
        onClick={addGroup}
        fullWidth
        size="large"
      >
        Add Group
      </Button>

      <Note>
        <b>Note:</b> Attendees created via widgets on this page will have the
        group <b>"CreatedByWidget"</b> added to their record, with the value{' '}
        <b>"true"</b>. This is for tracking purposes only.
      </Note>
    </>
  )
}

const Note = styled.div`
  padding: ${spacing[3]} 0;
  margin-top: ${spacing[4]};
  font-size: 0.8em;
  font-style: italic;
  color: #6a7181;
`

const StyledGroupInputHolder = styled.div`
  & > div > div {
    flex: 1;
  }
`
